import Stack from '@mui/material/Stack'
import React from 'react'
import { Helmet } from 'react-helmet'
import ToolsHeader from '../common/ToolsHeader'
import ParlayBuilder from './ParlayBuilder'
import { Container } from '@mui/material'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Authentication from '../common/Authentication'

const PickemOptimizer = () => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <Authentication app='PICKEM'>
        <Stack sx={{
          fontFamily: 'Inter',
          backgroundColor: '#101010',
          flexGrow: 1,
          height: '100vh',
          overflowX: 'hidden',
        }}>
          <Helmet>
            <title>Pick'Em Optimizer</title>
            <meta name="description" content="Stokastic Pick 6 Optimizer" />
          </Helmet>
          <ToolsHeader />
          <Container maxWidth='xl' sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: { xs: '0 8px', md: '24px' },
            height: '100%'
          }}>
            <ParlayBuilder />
          </Container>
        </Stack>
      </Authentication>
    </QueryClientProvider>
  )
}

export default PickemOptimizer